export default __webpack_public_path__ + "static/media/logo.f8983b56.jpg";